export default "__VITE_ASSET__B24Wwc6g__"